export const governanceTour = {
    module: 'governance',
    title: 'Governance Tour',
    title_vi: 'Hướng dẫn Quản trị',
    description: 'Explore Approvals, Audit Trail, Drift Monitor, Compliance Work Programme, Board Report and the related workspaces. Read the screens and controls without submitting business changes.',
    description_vi: 'Tìm hiểu Phê duyệt, Nhật ký kiểm toán, Giám sát lệch, Chương trình công việc tuân thủ, Báo cáo Ban Giám đốc và các không gian làm việc liên quan. Xem màn hình và điều khiển mà không gửi thay đổi nghiệp vụ.',
    estimated_duration_seconds: 561,
    revision: '2026-11-01.1',
    steps: [
        {
            step_id: 'explore_governance_approvals',
            navigate_to: '/admin/governance/approvals',
            target: '[data-testid="governance-approvals-page"] .dm-filters',
            wait_for: '[data-testid="governance-approvals-page"][data-tour-ready="true"]',
            title: 'Approvals',
            title_vi: 'Phê duyệt',
            description: 'Combine approval status and request type to find the decisions relevant to your role. Each request names the affected record and requester; inspect that context before making a decision. Viewing a pending request does not approve it, and requesters cannot approve their own requests.',
            description_vi: 'Kết hợp trạng thái phê duyệt và loại yêu cầu để tìm quyết định thuộc vai trò của bạn. Mỗi yêu cầu nêu bản ghi liên quan và người yêu cầu; kiểm tra ngữ cảnh trước khi quyết định. Xem yêu cầu đang chờ không phê duyệt yêu cầu đó, và người yêu cầu không thể tự phê duyệt.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'feature_approval_register',
            navigate_to: '/admin/governance/approvals',
            target: '[data-testid="governance-approvals-page"] > .dm-table-wrap',
            wait_for: '[data-testid="governance-approvals-page"][data-tour-ready="true"]',
            title: 'Read the Decision Context',
            title_vi: 'Đọc ngữ cảnh quyết định',
            description: 'The table links request type and affected entity with requester, request date, status and decision maker. Pending rows expose decision actions only to permitted users; an own-request note explains why self-approval is unavailable. Review the original record and supporting evidence before approving or rejecting. No decision is taken by this tour.',
            description_vi: 'Bảng nối loại yêu cầu và đối tượng liên quan với người yêu cầu, ngày yêu cầu, trạng thái và người quyết định. Dòng đang chờ chỉ có thao tác quyết định cho người có quyền; ghi chú yêu cầu của chính mình giải thích vì sao không thể tự phê duyệt. Rà soát bản ghi gốc và tài liệu chứng minh trước khi chấp thuận hoặc từ chối. Tour không đưa ra quyết định.',
            position: 'bottom',
            duration_ms: 21000,
        },
        {
            step_id: 'feature_approval_count',
            navigate_to: '/admin/governance/approvals',
            target: '[data-testid="governance-approvals-page"] > .dm-count',
            wait_for: '[data-testid="governance-approvals-page"][data-tour-ready="true"]',
            title: 'Reconcile the Filtered Queue',
            title_vi: 'Đối chiếu hàng đợi đã lọc',
            description: 'The count describes the current filtered approval queue. Clear or change filters when a request you expect is missing, and use pagination to reach the other matching rows. A zero result is not a statement that every organizational request has been decided. Exporting a register is a separate explicit action.',
            description_vi: 'Số đếm mô tả hàng đợi phê duyệt đang được lọc. Xoá hoặc đổi bộ lọc khi thiếu yêu cầu dự kiến, và dùng phân trang để xem các dòng phù hợp khác. Kết quả bằng không không khẳng định mọi yêu cầu của tổ chức đã được quyết định. Xuất sổ là thao tác chủ động riêng.',
            position: 'bottom',
            duration_ms: 20000,
        },
        {
            step_id: 'explore_governance_audit_trail',
            navigate_to: '/admin/governance/audit-trail',
            target: '[data-testid="governance-audit-trail-page"] .dm-filters',
            wait_for: '[data-testid="governance-audit-trail-page"][data-tour-ready="true"]',
            title: 'Audit Trail',
            title_vi: 'Nhật ký kiểm toán',
            description: 'Filter by entity, action and date to trace the governance event you need. Read actor and affected record before interpreting a change; this stream covers its recorded governance events, not every event elsewhere in the platform.',
            description_vi: 'Lọc theo thực thể, hành động và ngày để truy vết sự kiện quản trị cần xem. Đọc người thực hiện và bản ghi bị ảnh hưởng trước khi diễn giải thay đổi; luồng này bao gồm sự kiện quản trị được ghi, không phải mọi sự kiện trong nền tảng.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_governance_drift',
            navigate_to: '/admin/governance/drift',
            target: '[data-testid="governance-drift-page"] .dm-filters',
            wait_for: '[data-testid="governance-drift-page"][data-tour-ready="true"]',
            title: 'Drift Monitor',
            title_vi: 'Giám sát lệch',
            description: 'Compare severity, affected entity, drift type, status and assignee.',
            description_vi: 'So sánh mức độ nghiêm trọng, thực thể, loại sai lệch, trạng thái và người được giao.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_governance_drift_register',
            navigate_to: '/admin/governance/drift',
            target: '[data-tour-register="explore_governance_drift_register"]',
            wait_for: '[data-testid="governance-drift-page"][data-tour-ready="true"]',
            title: 'Drift Monitor — record decisions',
            title_vi: 'Giám sát lệch — quyết định theo bản ghi',
            description: 'Detection starts investigation; an assigned or filtered-out issue is not resolved. Inspect the source record before choosing remediation or a justified disposition.',
            description_vi: 'Phát hiện bắt đầu điều tra; đã giao hoặc bị lọc khỏi màn hình không có nghĩa đã giải quyết. Xem bản ghi nguồn trước khi chọn khắc phục hoặc kết luận có lý do.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_compliance_operations',
            navigate_to: '/admin/compliance-operations',
            target: '[data-testid="co-programme-page"] .dm-filters',
            wait_for: '[data-testid="co-programme-page"][data-tour-ready="true"]',
            title: 'Compliance Work Programme',
            title_vi: 'Chương trình công việc tuân thủ',
            description: 'Read duty scope and trigger before its timing and missing evidence.',
            description_vi: 'Đọc phạm vi và yếu tố kích hoạt nghĩa vụ trước thời hạn và tài liệu còn thiếu.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_compliance_operations_register',
            navigate_to: '/admin/compliance-operations',
            target: '[data-tour-register="explore_compliance_operations_register"]',
            wait_for: '[data-testid="co-programme-page"][data-tour-ready="true"]',
            title: 'Compliance Work Programme — record decisions',
            title_vi: 'Chương trình công việc tuân thủ — quyết định theo bản ghi',
            description: 'An empty register means no recorded duty matches this view, not that your organisation has no duties. In populated rows, distinguish statutory periods from recommended internal cadence; unresolved periods remain undated with their reason. Read missing-proof information alongside the separate coverage panel. Nothing here is a completion flag someone can set.',
            description_vi: 'Sổ trống nghĩa là không có nghĩa vụ đã ghi nào khớp chế độ xem này, không phải tổ chức không có nghĩa vụ. Trong các hàng hiện có, phân biệt khoảng thời gian theo pháp luật với nhịp nội bộ khuyến nghị; thời hạn chưa xác định vẫn không có ngày và có lý do. Đọc thông tin chứng cứ thiếu cùng bảng mức bao phủ riêng. Không có cờ hoàn thành nào ở đây để tự đặt.',
            position: 'bottom',
            duration_ms: 26000,
        },
        {
            step_id: 'explore_governance_board_report',
            navigate_to: '/admin/governance/board-report',
            target: '[data-testid="governance-board-report-page"] .dm-filters',
            wait_for: '[data-testid="governance-board-report-page"][data-tour-ready="true"]',
            title: 'Board Report',
            title_vi: 'Báo cáo Ban Giám đốc',
            description: 'Use the date range to define the reporting period and Language to choose the report’s language, independently of the interface language. This page starts with configuration rather than generated metrics; a later generated snapshot must be read against its selected period. Viewing requires score-read access; Generate needs the separate PDF export grant. The tour generates nothing.',
            description_vi: 'Dùng khoảng ngày để xác định kỳ báo cáo và Ngôn ngữ để chọn ngôn ngữ báo cáo, độc lập với ngôn ngữ giao diện. Trang ban đầu chỉ có cấu hình, chưa có chỉ số được tạo; báo cáo tạo sau đó phải được đọc theo kỳ đã chọn. Xem trang cần quyền đọc điểm; Tạo cần quyền xuất PDF riêng. Hướng dẫn không tạo báo cáo.',
            position: 'bottom',
            duration_ms: 23000,
        },
        {
            step_id: 'explore_governance_scores',
            navigate_to: '/admin/governance/scores',
            target: '[data-tour-feature="tour-governance-scores"]',
            wait_for: '[data-testid="governance-scores-page"][data-tour-ready="true"]',
            title: 'Compliance Score',
            title_vi: 'Điểm tuân thủ',
            description: 'Read the compliance score with its contributing factors and recommendations. A factor can be weak even when the overall score looks strong. Follow system, vendor, activity, ROPA or drift evidence behind the factor before using the score to plan work.',
            description_vi: 'Đọc điểm tuân thủ cùng các yếu tố và khuyến nghị. Một yếu tố có thể yếu dù điểm tổng thể cao. Theo tài liệu về hệ thống, nhà cung cấp, hoạt động, ROPA hoặc sai lệch đứng sau yếu tố trước khi dùng điểm để lập kế hoạch.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_governance_vendors',
            navigate_to: '/admin/governance/vendors',
            target: '[data-testid="governance-vendors-page"] .dm-filters',
            wait_for: '[data-testid="governance-vendors-page"][data-tour-ready="true"]',
            title: 'Vendors',
            title_vi: 'Nhà cung cấp',
            description: 'Compare vendor country, DPA status, risk, onboarding state and last review.',
            description_vi: 'So sánh quốc gia nhà cung cấp, trạng thái DPA, rủi ro, trạng thái tiếp nhận và lần rà soát cuối.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_governance_vendors_register',
            navigate_to: '/admin/governance/vendors',
            target: '[data-tour-register="explore_governance_vendors_register"]',
            wait_for: '[data-testid="governance-vendors-page"][data-tour-ready="true"]',
            title: 'Vendors — record decisions',
            title_vi: 'Nhà cung cấp — quyết định theo bản ghi',
            description: 'These fields describe different parts of the relationship; active onboarding does not establish a current DPA or review. Open the relevant vendor before planning follow-up.',
            description_vi: 'Các trường mô tả khía cạnh khác nhau; tiếp nhận đang hoạt động không xác nhận DPA hoặc rà soát còn hiện hành. Mở nhà cung cấp phù hợp trước khi theo dõi.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_governance_subprocessors',
            navigate_to: '/admin/governance/subprocessors',
            target: '[data-testid="subprocessors-section"]',
            wait_for: '[data-testid="subprocessors-section"][data-tour-ready="true"]',
            title: 'Sub-Processors',
            title_vi: 'Bên xử lý phụ',
            description: 'Trace the processor-to-subprocessor relationship alongside services, countries, DPA chain and status. A downstream relationship needs its own context; do not infer its agreement from the main vendor. An unreadable relationship list is different from a known empty list.',
            description_vi: 'Truy vết quan hệ bên xử lý với bên xử lý phụ cùng dịch vụ, quốc gia, chuỗi DPA và trạng thái. Quan hệ hạ nguồn cần bối cảnh riêng; không suy ra thỏa thuận từ nhà cung cấp chính. Danh sách không đọc được khác với danh sách đã xác định là trống.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_governance_cross_border',
            navigate_to: '/admin/governance/cross-border',
            target: '[aria-labelledby="cb-vendors-heading"]',
            wait_for: '[data-testid="cross-border-transfers"][data-tour-ready="true"]',
            title: 'Cross-Border',
            title_vi: 'Xuyên biên giới',
            description: 'Read the vendor transfer register with its source, destination, status and recorded mechanism. A configured mechanism describes an arrangement; it does not establish authority acceptance. Investigate the related assessment and safeguards before relying on the transfer record.',
            description_vi: 'Đọc sổ chuyển dữ liệu nhà cung cấp cùng nguồn, đích, trạng thái và cơ chế đã ghi. Cơ chế đã cấu hình mô tả thỏa thuận, không xác nhận cơ quan chấp nhận. Xem đánh giá và biện pháp bảo vệ liên quan trước khi dựa vào bản ghi.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'governance_cross_border_filings_state',
            navigate_to: '/admin/governance/cross-border',
            target: '[data-testid="cb-filings-section"]',
            wait_for: '[data-testid="cb-filings-section"][data-tour-ready="true"]',
            title: 'Read the separate filing lifecycle',
            title_vi: 'Đọc vòng đời hồ sơ nộp riêng',
            description: 'Filings are a separate read with their own access grant. Compare filing type, assessment reference, submission state and dates before following the authority outcome. A draft or submitted filing is not an accepted transfer authorisation.',
            description_vi: 'Hồ sơ nộp được đọc riêng với quyền truy cập riêng. So sánh loại hồ sơ, tham chiếu đánh giá, trạng thái và ngày nộp trước khi theo kết quả cơ quan. Hồ sơ nháp hoặc đã nộp chưa phải cho phép chuyển được chấp nhận.',
            position: 'bottom',
            duration_ms: 18000,
            required_permissions: ['gov:crossborder:filing:read'],
        },
        {
            step_id: 'explore_governance_offboarding',
            navigate_to: '/admin/governance/offboarding',
            target: '[data-testid="governance-offboarding-page"] .dm-filters',
            wait_for: '[data-testid="governance-offboarding-page"][data-tour-ready="true"]',
            title: 'Offboarding',
            title_vi: 'Ngừng hợp tác',
            description: 'Read each vendor offboarding item and its verification state before treating the relationship as closed. Workflow progress and evidence of completed deletion or termination are different facts. This tour neither starts offboarding nor confirms a checklist item.',
            description_vi: 'Đọc từng mục chấm dứt nhà cung cấp và trạng thái xác minh trước khi coi quan hệ đã đóng. Tiến độ quy trình và tài liệu chứng minh đã xóa hoặc chấm dứt là hai dữ kiện khác nhau. Hướng dẫn không bắt đầu chấm dứt hoặc xác nhận mục kiểm tra.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_governance_periodic_reviews',
            navigate_to: '/admin/governance/periodic-reviews',
            target: '[data-testid="governance-periodic-reviews-page"] .dm-filters',
            wait_for: '[data-testid="governance-periodic-reviews-page"][data-tour-ready="true"]',
            title: 'Periodic Reviews',
            title_vi: 'Đánh giá định kỳ',
            description: 'Compare vendor, review type, status, due date and next review.',
            description_vi: 'So sánh nhà cung cấp, loại rà soát, trạng thái, hạn và lần rà soát tiếp theo.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_governance_periodic_reviews_register',
            navigate_to: '/admin/governance/periodic-reviews',
            target: '[data-tour-register="explore_governance_periodic_reviews_register"]',
            wait_for: '[data-testid="governance-periodic-reviews-page"][data-tour-ready="true"]',
            title: 'Periodic Reviews — record decisions',
            title_vi: 'Đánh giá định kỳ — quyết định theo bản ghi',
            description: 'A scheduled next date does not show the current review was completed. Inspect overdue or outstanding work before changing the schedule.',
            description_vi: 'Ngày đã lên lịch không cho biết lần hiện tại đã hoàn thành. Xem việc quá hạn hoặc còn mở trước khi sửa lịch.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_governance_playbooks',
            navigate_to: '/admin/governance/playbooks',
            target: '[data-testid="governance-playbooks-page"] .dm-filters',
            wait_for: '[data-testid="governance-playbooks-page"][data-tour-ready="true"]',
            title: 'Playbooks',
            title_vi: 'Quy trình xóa',
            description: 'Compare playbook status, steps, estimated duration and data categories.',
            description_vi: 'So sánh trạng thái kịch bản, bước, thời lượng dự kiến và danh mục dữ liệu.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_governance_playbooks_register',
            navigate_to: '/admin/governance/playbooks',
            target: '[data-tour-register="explore_governance_playbooks_register"]',
            wait_for: '[data-testid="governance-playbooks-page"][data-tour-ready="true"]',
            title: 'Playbooks — record decisions',
            title_vi: 'Quy trình xóa — quyết định theo bản ghi',
            description: 'The definition says what should run; execution evidence says what actually ran. Inspect the relevant execution before treating a deletion-propagation playbook as fulfilled.',
            description_vi: 'Định nghĩa cho biết việc nên chạy; tài liệu thực thi cho biết việc đã chạy. Xem lần thực thi phù hợp trước khi coi kịch bản lan truyền xóa đã hoàn tất.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_governance_evidence',
            navigate_to: '/admin/governance/evidence',
            target: '[data-testid="governance-evidence-page"] .dm-filters',
            wait_for: '[data-testid="governance-evidence-page"][data-tour-ready="true"]',
            title: 'Evidence',
            title_vi: 'Bằng chứng',
            description: 'Read evidence name, type, tags, upload date and expiry before following its linked governance record.',
            description_vi: 'Đọc tên, loại, thẻ, ngày tải lên và hết hạn của tài liệu trước khi theo bản ghi quản trị liên kết.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_governance_evidence_register',
            navigate_to: '/admin/governance/evidence',
            target: '[data-tour-register="explore_governance_evidence_register"]',
            wait_for: '[data-testid="governance-evidence-page"][data-tour-ready="true"]',
            title: 'Evidence — record decisions',
            title_vi: 'Bằng chứng — quyết định theo bản ghi',
            description: 'A file’s presence does not establish that it is current or relevant to this decision. Linking, replacing or deleting evidence requires separate explicit action.',
            description_vi: 'Có tệp không xác nhận tệp còn hiện hành hoặc phù hợp với quyết định này. Liên kết, thay hoặc xóa tài liệu cần hành động riêng.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_trust_evidence_identities',
            navigate_to: '/admin/trust-evidence/identities',
            target: '[data-tour-feature="tour-trust-evidence-identities"]',
            wait_for: '[data-testid="te-identity-page"][data-tour-ready="true"]',
            title: 'Identity Register',
            title_vi: 'Sổ đăng ký danh tính (Identity Register)',
            description: 'Read subject kind and installed trust regime before interpreting identity verification records. The register holds evidence references and event metadata rather than attribute values. A recorded verification is scoped to its regime and event, not a general identity-equivalence claim.',
            description_vi: 'Đọc loại chủ thể và chế độ tin cậy đã cài trước khi diễn giải hồ sơ xác minh danh tính. Sổ giữ tham chiếu tài liệu và siêu dữ liệu sự kiện thay vì giá trị thuộc tính. Xác minh đã ghi gắn với chế độ và sự kiện, không phải khẳng định tương đương danh tính chung.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_trust_evidence_providers',
            navigate_to: '/admin/trust-evidence/providers',
            target: '[data-tour-feature="tour-trust-evidence-providers"]',
            wait_for: '[data-testid="te-providers-page"][data-tour-ready="true"]',
            title: 'Trust Providers',
            title_vi: 'Tổ chức cung cấp dịch vụ tin cậy (Trust Providers)',
            description: 'Compare provider name, registration reference and recorded standing under the installed regime. Credential issue, suspension, revocation and renewal history belongs to the selected provider or credential. Provider registration alone does not prove a particular credential remains valid.',
            description_vi: 'So sánh tên nhà cung cấp, tham chiếu đăng ký và tình trạng đã ghi theo chế độ cài đặt. Lịch sử cấp, tạm đình chỉ, thu hồi và gia hạn nằm ở nhà cung cấp hoặc chứng thư đã chọn. Đăng ký nhà cung cấp chưa chứng minh chứng thư cụ thể còn hợp lệ.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_trust_evidence_submissions',
            navigate_to: '/admin/trust-evidence/submissions',
            target: '[data-tour-feature="tour-trust-evidence-submissions"]',
            wait_for: '[data-testid="te-submissions-page"][data-tour-ready="true"]',
            title: 'Electronic Submissions',
            title_vi: 'Hồ sơ nộp điện tử (Electronic Submissions)',
            description: 'Read submission subject, framework, channel and status before opening its receipt history. A prepared payload and an authority receipt are separate evidence. This workspace records electronic filing facts; the walkthrough sends nothing.',
            description_vi: 'Đọc chủ đề nộp, khung, kênh và trạng thái trước khi mở lịch sử biên nhận. Dữ liệu chuẩn bị nộp và biên nhận của cơ quan là chứng cứ riêng. Không gian này ghi dữ kiện nộp điện tử; hướng dẫn không gửi gì.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_trust_evidence_agreements',
            navigate_to: '/admin/trust-evidence/agreements',
            target: '[data-tour-feature="tour-trust-evidence-agreements"]',
            wait_for: '[data-testid="te-agreements-page"][data-tour-ready="true"]',
            title: 'Electronic Agreements',
            title_vi: 'Thỏa thuận điện tử (Electronic Agreements)',
            description: 'Compare agreement reference, title, kind and state. Parties, signature evidence and synchronisation traces are inspected in the selected agreement. A listed agreement is not by itself proof that every signature was verified or every trace completed.',
            description_vi: 'So sánh tham chiếu, tiêu đề, loại và trạng thái thỏa thuận. Các bên, tài liệu chữ ký và dấu vết đồng bộ được xem trong thỏa thuận đã chọn. Có thỏa thuận trong sổ chưa tự chứng minh mọi chữ ký đã xác minh hoặc mọi đồng bộ hoàn thành.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_trust_evidence_identity_exchanges',
            navigate_to: '/admin/trust-evidence/identity-exchanges',
            target: '[data-tour-feature="tour-trust-evidence-identity-exchanges"]',
            wait_for: '[data-testid="ie-page"][data-tour-ready="true"]',
            title: 'Cross-Border Identity Exchanges',
            title_vi: 'Trao đổi định danh xuyên biên giới (Cross-Border Identity Exchanges)',
            description: 'Compare provider, relying party, countries and recorded flow state. Testing and production are distinct states with recorded prerequisites; inspect attribute basis, minimisation, transfer assessment and authorisation in the selected flow. No interoperability or national-system equivalence is established here.',
            description_vi: 'So sánh bên cung cấp, bên dựa vào danh tính, quốc gia và trạng thái luồng. Thử nghiệm và vận hành là trạng thái riêng với điều kiện đã ghi; xem căn cứ thuộc tính, giảm thiểu dữ liệu, đánh giá chuyển và cho phép trong luồng đã chọn. Bước này không xác nhận khả năng liên thông hoặc tương đương hệ thống quốc gia.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_regulatory_artifacts',
            navigate_to: '/admin/regulatory-artifacts',
            target: '#ra-catalog-search',
            wait_for: '[data-testid="ra-catalog-page"][data-tour-ready="true"]',
            title: 'Artifact Catalog',
            title_vi: 'Danh mục tài liệu (Artifact Catalog)',
            description: 'Search the artifact catalogue, then narrow the register by kind, access tier, verification status or installed framework. Kind describes what a document is; access tier describes who may see it. Review the matching record and its source before choosing an operational action. This walkthrough does not open or run an export.',
            description_vi: 'Tìm trong danh mục tài liệu, rồi lọc sổ theo loại tài liệu, cấp truy cập, trạng thái xác minh hoặc khung đã cài đặt. Loại tài liệu mô tả tài liệu đó là gì; cấp truy cập mô tả ai được xem. Xem bản ghi phù hợp và nguồn của nó trước khi chọn thao tác nghiệp vụ. Hướng dẫn này không mở hoặc thực hiện xuất dữ liệu.',
            position: 'bottom',
            duration_ms: 21000,
        },
        {
            step_id: 'explore_regulatory_artifacts_grants',
            navigate_to: '/admin/regulatory-artifacts/grants',
            target: '[data-tour-feature="tour-regulatory-artifacts-grants"]',
            wait_for: '[data-testid="ra-access-page"][data-tour-ready="true"]',
            title: 'Restricted Access',
            title_vi: 'Quyền truy cập hạn chế (Restricted Access)',
            description: 'Compare restricted artifact, grantee, purpose and validity window before interpreting an access grant. The grant and the immutable access record answer different questions: permission to access versus observed attempts. Custody and optional policy settings have separate permissions.',
            description_vi: 'So sánh tài liệu hạn chế, người được cấp, mục đích và thời gian hiệu lực trước khi diễn giải quyền truy cập. Quyền và bản ghi truy cập bất biến trả lời câu hỏi khác nhau: được phép truy cập và lần thử đã quan sát. Quản lý lưu giữ và chính sách tùy chọn có quyền riêng.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_regulatory_artifacts_verification',
            navigate_to: '/admin/regulatory-artifacts/verification',
            target: '[data-tour-feature="tour-regulatory-artifacts-verification"]',
            wait_for: '[data-testid="ra-queue-page"][data-tour-ready="true"]',
            title: 'Verification Queue',
            title_vi: 'Hàng đợi xác minh (Verification Queue)',
            description: 'Read title, framework, candidate kind and verification state in the queue. An unclassified artifact remains unresolved until a permitted person records a classification decision. Queue presence is not an official badge or verification outcome.',
            description_vi: 'Đọc tiêu đề, khung, loại dự kiến và trạng thái xác minh trong hàng đợi. Tài liệu chưa phân loại vẫn chưa được giải quyết cho đến khi người có quyền ghi quyết định. Có trong hàng đợi không phải dấu xác nhận chính thức hoặc kết quả xác minh.',
            position: 'bottom',
            duration_ms: 18000,
        },
    ],
};
//# sourceMappingURL=governance.js.map